import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReportComponent } from '@app/main/report/report.component';
import { CanDeactivateGuard } from '@shared/directives/can-deactivate-guard.directive';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
    {
        path: ':reportId',
        component: ReportComponent,
        canActivate: [MsalGuard],
        canDeactivate: [CanDeactivateGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ReportRoutingModule {}
